var map = {
	"./css/video-js.min.css": "fe6a",
	"./css/videojs.record.css": "3f83",
	"./fonts/Colfax-Black.otf": "8353",
	"./fonts/Colfax-Bold.otf": "dab7",
	"./fonts/Colfax-Medium.otf": "553b",
	"./fonts/Colfax-Regular.otf": "85c1",
	"./fonts/MarkerFelt-Thin.otf": "c90f",
	"./fonts/MaterialIcons-Regular.ttf": "0fe5",
	"./fonts/silka-regular.ttf": "1b4b",
	"./img/Iphone.svg": "6c1e",
	"./img/Mail.svg": "3545",
	"./img/Screen.svg": "d541",
	"./img/countdown.gif": "8fbf",
	"./img/countdown2.gif": "a647",
	"./img/logo-continium-positief@2x.png": "0005",
	"./img/mock-player-bar.png": "03d0",
	"./img/museum.png": "0c1d",
	"./img/play.png": "d99c",
	"./img/share-email-2-bg.png": "5d0d",
	"./img/strand.png": "ddb1",
	"./img/studio.jpg": "b809",
	"./img/vlogger.jpg": "4250",
	"./json/APIDataExampleFallback": "a757",
	"./json/APIDataExampleFallback.json": "a757",
	"./scss/_fonts.scss": "b0e8",
	"./scss/_variables.scss": "fb51",
	"./scss/countdown.scss": "9c6e",
	"./scss/fonts.scss": "d624",
	"./scss/main.scss": "c1c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";